import { createContext } from 'react';

export interface User {
  email: string;
}

interface IAuthContext {
  user: User | null;
  setUser: (user: User | null) => void;
  isAuthenticated: boolean;
  checkAuth: () => void;
}

export const AuthContext = createContext<IAuthContext>({
  user: null,
  setUser: () => { },
  isAuthenticated: false,
  checkAuth: () => { },
});
